(function () {
  "use strict";

  function parseMoney(value) {
    if (!value) return NaN;
    var normalized = String(value)
      .replace(/\s/g, "")
      .replace(/[^0-9,.-]/g, "");

    if (!normalized) return NaN;

    var lastComma = normalized.lastIndexOf(",");
    var lastDot = normalized.lastIndexOf(".");

    if (lastComma > lastDot) {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    } else {
      normalized = normalized.replace(/,/g, "");
    }

    return Number(normalized);
  }

  function getPriceValues(priceRoot) {
    if (!priceRoot) return null;

    // Prefer data-* attributes to reduce dependency on classes.
    var saleEl = priceRoot.querySelector(".price__sale [data-sale-price]") || priceRoot.querySelector(".price__sale .price-item--sale");
    var compareEl = priceRoot.querySelector(".price__sale [data-regular-price]") || priceRoot.querySelector(".price__sale .price-item--regular");
    var regularEl = priceRoot.querySelector(".price__regular [data-regular-price]") || priceRoot.querySelector(".price__regular .price-item--regular");

    var salePrice = saleEl ? parseMoney(saleEl.textContent) : NaN;
    var comparePrice = compareEl ? parseMoney(compareEl.textContent) : NaN;
    var regularPrice = regularEl ? parseMoney(regularEl.textContent) : NaN;

    if (Number.isFinite(comparePrice) && Number.isFinite(salePrice)) {
      return { regular: comparePrice, sale: salePrice };
    }

    if (Number.isFinite(regularPrice) && Number.isFinite(salePrice) && regularPrice > salePrice) {
      return { regular: regularPrice, sale: salePrice };
    }

    return null;
  }

  function resolveDiscountPercentage(regular, sale) {
    // Return `null` when no discount exists (or when values are invalid).
    // When a discount exists but the percentage rounds to 0, return 0 so the badge still appears.
    if (!Number.isFinite(regular) || !Number.isFinite(sale)) return null;
    if (regular <= 0 || regular <= sale) return null;
    return Math.round(((regular - sale) / regular) * 100);
  }

  function updateBadgeElement(badge, percent) {
    if (!badge) return;

    var valueNode = badge.querySelector("[data-discount-value]");
    if (!valueNode || percent === null) {
      badge.hidden = true;
      badge.classList.remove("discount-badge-native--two-digits");
      return;
    }

    var percentText = String(percent);
    if (valueNode.textContent !== percentText) {
      valueNode.textContent = percentText;
    }

    badge.classList.toggle(
      "discount-badge-native--two-digits",
      percentText.length >= 2
    );

    badge.hidden = false;
  }

  function updateListingBadges() {
    var cards = document.querySelectorAll("#main-collection-product-grid .product-index, #main-search-results .product-index");
    cards.forEach(function (card) {
      var badge = card.querySelector("[data-discount-badge]");
      var price = card.querySelector(".price.price--listing");

      if (!badge || !price) return;

      var values = getPriceValues(price);
      var percent = values ? resolveDiscountPercentage(values.regular, values.sale) : null;
      updateBadgeElement(badge, percent);
    });
  }

  function updateProductBadges() {
    var priceRoots = document.querySelectorAll("[id^='product-price'].price[data-price], .template-product .price[data-price], .template-product-new-pdp .price[data-price]");
    priceRoots.forEach(function (priceRoot) {
      var badge = priceRoot.querySelector("[data-discount-badge]");
      if (!badge) {
        // Search for the badge in a few following siblings in case there are intermediate elements.
        var next = priceRoot.nextElementSibling;
        var steps = 0;
        while (next && steps < 5) {
          if (next.matches && next.matches("[data-discount-badge]")) {
            badge = next;
            break;
          }
          next = next.nextElementSibling;
          steps += 1;
        }
      }
      if (!badge) return;

      var values = getPriceValues(priceRoot);
      var percent = values ? resolveDiscountPercentage(values.regular, values.sale) : null;
      updateBadgeElement(badge, percent);
    });
  }

  function run() {
    var body = document.body;
    if (!body) return;

    if (body.classList.contains("template-collection") || body.classList.contains("template-search")) {
      updateListingBadges();
    }

    if (body.classList.contains("template-product") || body.classList.contains("template-product-new-pdp")) {
      updateProductBadges();
    }
  }

  function debounce(fn, delay) {
    var timer = null;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  var debouncedRun = debounce(run, 40);

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
  document.addEventListener("change", function (event) {
    if (!event.target) return;
    if (event.target.closest(".js-variant-selector") || event.target.classList.contains("formVariantId")) {
      debouncedRun();
    }
  });

  // Theme updates variant inputs and prices dynamically; observe only price blocks.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      if (mutations[i].target && mutations[i].target.closest && mutations[i].target.closest(".price[data-price]")) {
        debouncedRun();
        break;
      }
    }
  });

  function observePriceRoots() {
    var roots = document.querySelectorAll(".price[data-price]");
    roots.forEach(function (root) {
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  document.addEventListener("DOMContentLoaded", observePriceRoots);
  window.addEventListener("load", observePriceRoots);

  function bindThemeVariantEvents() {
    if (!window.Events || typeof window.Events.on !== "function") return;
    window.Events.on("variantchange", debouncedRun);
    window.Events.on("variantunavailable", debouncedRun);
  }

  document.addEventListener("DOMContentLoaded", bindThemeVariantEvents);

  function observeCollectionGrid() {
    var body = document.body;
    if (!body) return;

    var grid = null;
    if (body.classList.contains("template-collection")) {
      grid = document.getElementById("main-collection-product-grid");
    } else if (body.classList.contains("template-search")) {
      grid = document.getElementById("main-search-results");
    }

    if (!grid) return;

    var gridObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          debouncedRun();
          break;
        }
      }
    });

    gridObserver.observe(grid, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", observeCollectionGrid);
})();
